import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { renderUserName } from "../../../utils/helpers/user";
import { useCompanyDateFormat } from "../../../utils/hooks/company";

const columnHelper = createColumnHelper();

export const useColumns = ({ edit, remove }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    return useMemo(() => {
        const columns = [
            columnHelper.accessor("pbjCode.code", {
                header: t("code"),
                cell: (info) => {
                    const value = info.getValue();
                    return value;
                }
            }),
            columnHelper.accessor("pbjCode.description", {
                header: t("description"),
                cell: (info) => {
                    const value = info.getValue();
                    return value;
                }
            }),
            columnHelper.accessor("startEffectiveDate", {
                header: t("start-effective-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat);
                }
            }),
            columnHelper.accessor("endEffectiveDate", {
                header: t("end-effective-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat);
                }
            }),
            columnHelper.accessor("createdBy", {
                header: t("created-by"),
                cell: (info) => {
                    const value = info.getValue();
                    return renderUserName(value)
                }
            }),
            columnHelper.accessor("createdAt", {
                header: t("created-at"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat)
                }
            }),
            columnHelper.accessor("updatedBy", {
                header: t("updated-by"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && renderUserName(value)
                }
            }),
            columnHelper.accessor("updatedAt", {
                header: t("updated-at"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat)
                }
            }),
            (!!edit || !!remove) && columnHelper.display({
                id: "actions",
                enableHiding: false,
                enableColumnFilter: false,
                header: (
                    <div className="text-right">
                        {t("actions")}
                    </div>
                ),
                cell: (info) => {
                    const row = info.row.original;
                    const { id } = row;

                    return (
                        <div className="actions text-primary text-right">
                            {edit && (
                                <span
                                    className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                    onClick={() => edit(row)}
                                    style={{ cursor: "pointer" }}
                                    role="button"
                                >
                                    <i className="fas fa-pen" />
                                </span>
                            )}
                            {remove && (
                                <span
                                    className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                    onClick={() => remove(id)}
                                    style={{ cursor: "pointer" }}
                                    role="button"
                                >
                                    <i className="fas fa-trash" />
                                </span>
                            )}
                        </div>
                    );
                }
            })
        ];
        return columns.filter((column) => !!column);
    }, [t, edit, remove]);
};